import { FormItem, SelectInput, StyledForm } from '@framework/form';
import { ButtonProps } from 'antd';
import * as React from 'react';
import { IReference } from '../../../references/IReference';
import { IAsyncService } from '../context/IAsyncService';
import { AsyncServiceInputsInput } from './AsyncServiceInputsInput';

export interface IAsyncExpressionOptionsInputProps {
  service: IAsyncService | undefined;
  references: IReference[];
  name: string;
  size?: ButtonProps['size'];
}

export function AsyncExpressionOptionsInput(
  props: IAsyncExpressionOptionsInputProps,
) {
  const { service, references, name, size } = props;
  if (!service) return null;

  return (
    <StyledForm>
      <FormItem name={`${name}.inputs`} label="Input">
        <AsyncServiceInputsInput
          name={`${name}.inputs`}
          service={service}
          references={references}
          size={size}
        />
      </FormItem>
      <FormItem
        name={`${name}.output`}
        label="Output"
        layout={{ removeHelpMargin: true }}
      >
        <SelectInput
          size={size}
          name={`${name}.output`}
          options={service.outputs.map(output => ({
            value: output.name,
            label: output.name,
          }))}
        />
      </FormItem>
    </StyledForm>
  );
}
